import React from 'react';
import styled from 'styled-components';
import DocumentDetailSkeleton from './DocumentDetailSekeleton';

const Wrapper = styled.div`
&.sriEngagementSkeleton {
  padding: 0;
  padding-bottom: 16px;
}
  padding: 0 30px;
  padding-bottom: 16px;
`;
type Props = {
  customClassName?: string,
} & typeof defaultProps;
const defaultProps = {
  customClassName: '',
};
const DocumentHubTableSkeleton = function DocumentHubTableSkeleton(props: Props) {
  const { customClassName } = props;
  return (
    <Wrapper className={`document-hub-table-skelton-wrapper ${customClassName}`}>
      {[1, 2, 3].map(() => (
        <DocumentDetailSkeleton />
      ))}
    </Wrapper>
  );
};
DocumentHubTableSkeleton.defaultProps = defaultProps;
export default DocumentHubTableSkeleton;
